import raw from "raw.macro";

const stripMarkdown = (md) =>
  (md || "")
    .replace(/```[\s\S]*?```/g, " ")
    .replace(/`[^`]*`/g, " ")
    .replace(/!\[[^\]]*]\([^)]+\)/g, " ")
    .replace(/\[[^\]]*]\([^)]+\)/g, " ")
    .replace(/[#>*_~\-]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const helpArticles = [
   {
    id: "checklista-wycieczki",
    title: "Checklista osoby koordynatorskiej",
    summary: "Ogólny plan tego co robić przed, w trakcie i po wycieczce.",
    updatedAt: "2026-02-28",
    isPinned: true,
    content: raw("./articles/checklista-wycieczki.md"),
  },
  {
    id: "mechanizm-korekt",
    title: "Mechanizm korekt – jak ułatwić sobie życie",
    summary: "Kiedy używać korekt i jak wpływają na saldo uczestnika.",
    updatedAt: "2026-02-27",
    content: raw("./articles/mechanizm-korekt.md"),
  },
  {
    id: "pokrycie-kosztow-osoby-koo",
    title: "Pokrycie kosztów osoby koordynatorskiej",
    summary: "Jak ustawić zaliczkę i korekty, aby koszt udziału koordynatora wynosił 0 zł.",
    updatedAt: "2026-02-27",
    content: raw("./articles/pokrycie-kosztow-osoby-koo.md"),
  },
    {
    id: "rezerwacja-osoby-koordynatorskiej",
    title: "Rezerwacja osoby koordynatorskiej",
    summary: "Jak zapisać się przed oficjalnymi zapisami i uwzględnić swoją osobę towarzyszącą.",
    updatedAt: "2026-02-27",
    content: raw("./articles/rezerwacja-osoby-koordynatorskiej.md"),
  },
      {
    id: "discord",
    title: "Kanał wycieczki na discordzie",
    summary: "Jak utworzyć i zarządzać dostępem do kanału Discord? Jak wysyłać automatyczne wiadomości o dostępie i zgodach wizerunkowych?",
    updatedAt: "2026-02-27",
    content: raw("./articles/discord.md"),
  },
   {
    id: "lista-rezerwowa",
    title: "Lista rezerwowa - zarządzanie przypadkami",
    summary: "Jak przenosić rezerwacje z listy rezerwowej na listę aktywnych i reagować w szczególnych przypadkach",
    updatedAt: "2026-02-27",
    content: raw("./articles/lista-rezerwowa.md"),
  },
     {
    id: "zasoby",
    title: "Zasoby (naklejki, krótkofalówki, flagi, etc.)",
    summary: "Jak aktualizować swój stan posiadania  naklejek, pinów, naszywek? Jak przekazać krótkofalówki, flagi, apteczki innej osobie koordynatorskiej?",
    updatedAt: "2026-02-27",
    content: raw("./articles/zasoby.md"),
  },
       {
    id: "anulowanie-rezerwacji",
    title: "Anulowanie rezerwacji i osób",
    summary: "Jak anulować osobę z rezerwacji? Jak anulować rezerwację i ustalić kwotę ewentualnego zwrotu?",
    updatedAt: "2026-02-27",
    content: raw("./articles/anulowanie-rezerwacji.md"),
  },
         {
    id: "reczne-potwierdzenie-rezerwacji",
    title: "Potwierdzenie rezerwacji",
    summary: "W jaki sposób ręcznie potwierdzić rezerwację i kiedy należy to wykonać?",
    updatedAt: "2026-02-27",
    content: raw("./articles/reczne-potwierdzanie-rezerwacji.md"),
  },
    {
    id: "statusy-rezerwacji",
    title: "Statusy rezerwacji",
    summary: "Co oznaczają statusy rezerwacji i czy wymagają jakiejś akcji? Czym jest symbol domku lub notatki na liście rezerwacji?",
    updatedAt: "2026-02-27",
    content: raw("./articles/statusy-rezerwacji.md"),
  },
].map((a) => ({ ...a, contentPlain: stripMarkdown(a.content) }))
.sort((a, b) =>
    a.title.localeCompare(b.title, "pl", { sensitivity: "base" }));